var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../templates/entertainment_and_office_table.template.html');
require('../../libs/handlebars/handlebars-helpers.ts');

var TheView = GenericView.extend({
    el: '#entertainment_office .table-container',
    tagName: '',
	template: Handlebars.compile(Template),
	initialize: function (options) {
        this.render();
    },
    superRender: GenericView.prototype.render,
    render: function () {
        this.superRender();
        var params = {
            appliances: [
                {title: "1. Laptop", applianceType: "Laptop"},
                {title: "2. Desktop", applianceType: "Personal_Computer"},
                {title: "3. Projector", applianceType: "Projector"},
                {title: "4. Printer", applianceType: "Printer"},
                {title: "5. Scanner", applianceType: "Scanner"},
                {title: "6. Fax", applianceType: "Fax"},
                {title: "7. Answering machine", applianceType: "Answering_Machine"},
                {title: "8. TV set", applianceType: "TV"},
                {title: "9. Set-top box", applianceType: "Set_Top_Box"},
                {title: "10. Home cinema", applianceType: "Home_Cinema"},
                {title: "11. DVD-VCR", applianceType: "VCR_DVD"},
                {title: "12. Radio", applianceType: "Clock_Radio"},
                {title: "13. Hi-fi system", applianceType: "Hi_Fi"},
                {title: "14. Game console", applianceType: "Game_Console"},
                {title: "15. Cordless telephone", applianceType: "Cordless_Telephone"}
            ]
        };

        this.$el.html(this.template(params));
    }
});

module.exports= TheView;